export default {
  app: {
    name: "Sportsbook",
    full: "Back Office Template",
    minimized: "BO"
  },
  no_records: "No records",
  welcome: "Welcome back, {user}!",
  login: "Sign In to your account",
  login_success: "Login successfully",
  relogin: "Please re-login to your account again.",
  expired: "Your session has expired.",
  denied: "Permission Denied!",
  success: "You have successfully completed!",
  select_date_range: "Please select date",
  permission_denied: "You are not authorised to perform this action!",
  search_by_id_name: "Search by ID or Name",
  search_by_name: "Search by Name",
  close: "Account closed. Please contact your addministrator.",
  suspend: "Account suspended. Please contact your addministrator.",
  suspend_alert1: "Your account has been changed to \"View Only\".",
  suspend_alert2: "Kindly refer to your Upline.",
  freeze: "Account freezed. Please contact your addministrator.",
  account_id_length_error: "Invalid account id length",
  change_user_status_confirm: "Are you sure you want to change the Account Status?",
  delete_confirm: "Are you sure you want to delete \"{name}\"?",
  update_account_status_confirm: "Are you sure want to update account status?",
  update_account_status_cancel: "Update account status failed.",
  update_account_status_success: "Account status successfully updated!",
  update_account_password_confirm: "Are you sure want to update account password?",
  update_account_password_cancel: "Update account password failed.",
  update_account_password_success: "Password successfully updated!",
  update_account_password_success1: "Password successfully updated! Please relogin again.",
  update_password_failed: "Failed to update password.",
  update_account_security_confirm: "Are you sure want to update account security?",
  update_account_security_cancel: "Update account security failed.",
  update_account_security_success: "Account security successfully updated!",
  update_account_authority_confirm: "Are you sure want to update account authority?",
  update_account_authority_cancel: "Update account authority failed.",
  update_account_authority_success: "Account authority successfully updated!",
  block_sub_account_confirm: "Are you sure want to block sub account?",
  block_sub_account_cancel: "Block sub account failed.",
  block_sub_account_success: "Sub account successfully blocked!",
  unblock_sub_account_confirm: "Are you sure want to unblock sub account?",
  unblock_sub_account_cancel: "Unblock sub account failed.",
  unblock_sub_account_success: "Sub account successfully unblocked!",
  successful_update_profile: "You have successfully update profile.",
  successful_update_security: "You have successfully update security code.",
  successful_create_account: "You have successfully created new account. ",
  update_platform_settings_confirm: "Are you sure want to update platform settings?",
  update_platform_settings_cancel: "Update platform settings failed.",
  update_platform_settings_success: "Platform settings successfully updated!",
  update_partner_sports_confirm: "Are you sure want to update partner sports settings?",
  update_partner_sports_cancel: "Update partner sports settings failed.",
  update_partner_sports_success: "Partner sports settings successfully updated!",
  update_partner_market_confirm: "Are you sure want to update partner market settings?",
  update_partner_market_cancel: "Update partner market settings failed.",
  update_partner_market_success: "Partner market settings successfully updated!",
  update_partner_bet_type_confirm: "Are you sure want to update partner bet type settings?",
  update_partner_bet_type_cancel: "Update partner bet type settings failed.",
  update_partner_bet_type_success: "Partner bet type settings successfully updated!",
  partner_ldiff_margin_priority: "Note: The LDiff / Margin priority is Bet Type > Market Type > Sports Type. Please take note of this priority when making any changes.",
  reset_accumulate_win_confirm: "Are you sure want to reset accumualte win limit?",
  reset_accumulate_win_cancel: "Reset accumulate win limit failed.",
  reset_accumulate_win_success: "Accumulate win limit successfully reset!",
  parent_platform_disabled: "Upline platform settings has been disabled.",
  copy_success: "The account information has been copied to clipboard.",
  copy_failed: "Your browser doesn't support copied to clipboard.",
  copy_all_upline: "Copy soccer HDP upline to all sport types",
  copy_all_account: "Copy soccer HDP account to all sport types",
  copy_all_remaining: "Copy soccer HDP remaining to all sport types",
  copy_all_min: "Copy soccer HDP min to all sport types",
  copy_all_min_bet: "Copy soccer min bet to all sport types",
  copy_all_max_bet: "Copy soccer max bet to all sport types",
  copy_all_max_per_match: "Copy soccer max per match to all sport types",
  create_secondary_account_success: "Secondary account successfully created! Please relogin again.",
  first_sub_account_success: "Sub account successfully updated! Please relogin again.",
  update_account_commission_confirm: "Are you sure want to update account commission?",
  update_account_commission_cancel: "Update account commission failed.",
  update_account_commission_success: "Account commission successfully updated!",
  update_account_position_confirm: "Are you sure want to update account position taking?",
  update_account_position_cancel: "Update account position taking failed.",
  update_account_position_success: "Account position taking successfully updated!",
  update_account_bet_limit_confirm: "Are you sure want to update account bet limit?",
  update_account_bet_limit_cancel: "Update account bet limit failed.",
  update_account_bet_limit_success: "Account bet limit successfully updated!",
  update_account_profile_confirm: "Are you sure want to update account profile?",
  update_account_profile_cancel: "Update account profile failed.",
  update_account_profile_success: "Account profile successfully updated!",
  create_new_account_confirm: "Are you sure want to create new account?",
  create_new_account_cancel: "Create new account failed",
  create_new_account_success: "New account successfully created!",
  create_sub_account_confirm: "Are you sure want to create sub account?",
  create_sub_account_cancel: "Create sub account failed",
  create_sub_account_success: "Sub account successfully created!",
  update_sub_account_confirm: "Are you sure want to update sub account?",
  update_sub_account_cancel: "Update sub account failed",
  update_sub_account_success: "Sub account successfully updated!",
  unblock_account_profile_confirm: "Are you sure want to unblock account profile?",
  unblock_account_profile_cancel: "Unblock account profile failed.",
  unblock_account_profile_success: "Account profile successfully unblocked!",
  settlement_confirm: "Are you sure want to proceed settlement?",
  settlement_cancel: "Settlement failed",
  settlement_success: "Settlement successfully processed!",
  settlement_not_allowed: "Settlement is not allowed today!",
  search_with_working_date: "Search with working date",
  system_error: "System unable to process your request.",
  invalid_password: "Invalid Username or Password.",
  invalid_account: "Invalid account.",
  block: "Your account has been blocked.",
  invalid_security_code: "Invalid security code.",
  source_account_id_required: "Account ID is required.",
  target_account_id_required: "Target account ID is required.",
  account_id_required: "Account ID is required.",
  sub_login_id_required: "Login ID is required.",
  account_not_exists: "Invalid account.",
  profile_not_exists: "Invalid account.",
  account_inactive: "Inactive account.",
  not_blocked_account: "Valid account.",
  password_required: "Password is required.",
  parent_id_required: "Parent ID is required.",
  parent_not_exists:"Invalid account.",
  invalid_account_type: "Invalid account type.",
  account_exists: "Account is already exists.",
  login_id_required: "Login ID is required.",
  new_login_id_required: "New login ID is required.",
  login_id_not_exists: "Invalid login ID.",
  invalid_authority_role: "Invalid role.",
  profile_inactive: "Invalid profile.",
  secondary_account_exists: "Secondary account is already exists.",
  secondary_id_acknowledge_checkbox: "I acknowledge that I will use the Secondary ID to login in the next login.",
  new_login_id_exists: "New login ID is already exists.",
  new_password_required: "New password is required.",
  security_tag_required: "Security tag is required.",
  security_code_required: "Security code is required.",
  start_date_required: "Start date is required.",
  end_date_required: "End date is required.",
  start_date_gt_end_date: "Start date is greater than end date.",
  start_date_greater_end_date: "Start date is greater than end date.",
  member_id_required: "Member ID is required.",
  currency_code_required: "Currency code is required.",
  commission_setting_not_exists: "Commission setting does not exists.",
  incomplete_account_line: "Incomplete account line.",
  invalid_hdp_package: "Invalid HDP packages.",
  search_id_required: "Search ID is required.",
  profile_id_required: "Profile ID is required.",
  login_not_exists: "Invalid login ID.",
  no_changes: "There is no changes detected.",
  start_date_require: "Start date is required.",
  league_id_required: "League ID is required.",
  sport_type_required: "Sport Type is reuired.",
  match_id_required: "Match ID is required.",
  target_login_id_required: "Target login ID is required.",
  parent_account_not_exists: "Invalid account.",
  parent_account_inactive: "Inactive parent account.",
  parent_profile_not_exists: "Invalid account..",
  parent_profile_inactive: "Inactive parent profile.",
  target_login_id_not_exists: "Invalid account.",
  incorrect_parent: "Invalid parent ID.",
  invalid_session: "Invalid session request.",
  session_expired: "Session expired.",
  settle_amount_required: "Settle amount is required.",
  invalid_settle_amount: "Invalid settle amount.",
  settle_amount_gt_yesterday_balance: "Settle amount is greater than yesterday balance.",
  invalid_account_status: "Invalid account status.",
  bet_limit_packages_required: "Bet limit packages are required.",
  bet_limit_exists: "Bet limit is already exists.",
  member_bet_limit_package_gt_one: "Member bet limit packages is more than one.",
  parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  account_commission_required: "Account commission is required.",
  commission_setting_exists: "Commission setting already exists.",
  parent_comm_not_exists: "Parent commission setting does not exits.",
  exceeded_parent_comm: "Exceeded parent commission setting.",
  others_commission_required: "Others commission setting is required.",
  exceeded_parent_1x2: "Exceeded parent 1x2 commission setting.",
  exceeded_parent_other: "Exceeded parent other commission setting.",
  hdp_commission_required: "HDP commission setting is required.",
  exceeded_parent_hdp_a: "Exceeded parent HPD(A) commission setting.",
  exceeded_parent_hdp_b: "Exceeded parent HPD(B) commission setting.",
  exceeded_parent_hdp_c: "Exceeded parent HPD(C) commission setting.",
  exceeded_parent_hdp_d: "Exceeded parent HPD(D) commission setting.",
  exceeded_parent_hdp_e: "Exceeded parent HPD(E) commission setting.",
  exceeded_parent_hdp_f: "Exceeded parent HPD(F) commission setting.",
  exceeded_parent_hdp_g: "Exceeded parent HPD(G) commission setting.",
  exceeded_parent_hdp_h: "Exceeded parent HPD(H) commission setting.",
  exceeded_parent_hdp_i: "Exceeded parent HPD(I) commission setting.",
  exceeded_parent_hdp_j: "Exceeded parent HPD(J) commission setting.",
  livecasino_upline_pt_required: "[Livecasino] Upline PT setting is required.",
  livecasino_pt_setting_exists: "[Livecasino] PT setting is exists.",
  livecasino_parent_pt_not_exists: "[Livecasino] Parent PT setting does not exists.",
  livecasino_parent_min_not_meet: "[Livecasino] Does not match with parent minimum PT.",
  livecasino_exceeded_parent_pt: "[Livecasino] Exceeded parent PT setting.",
  livecasino_account_pt_required: "[Livecasino] Account PT setting is required.",
  livecasino_upline_remaining_required: "[Livecasino] Upline remaining PT setting is required.",
  livecasino_account_min_required: "[Livecasino] Account minimum PT setting is required.",
  livecasino_upline_remaining_gt_account_pt: "[Livecasino] Upline remaining PT setting is greater than account PT setting.",
  livecasino_account_min_gt_p: "[Livecasino] Account minimum PT setting is greater than parent PT setting.",
  slots_upline_pt_required: "[Slots] Upline PT setting is required.",
  slots_pt_setting_exists: "[Slots] PT setting is exists.",
  slots_parent_pt_not_exists: "[Slots] Parent PT setting does not exists.",
  slots_parent_min_not_meet: "[Slots] Does not match with parent minimum PT.",
  slots_exceeded_parent_pt: "[Slots] Exceeded parent PT setting.",
  slots_account_pt_required: "[Slots] Account PT setting is required.",
  slots_upline_remaining_required: "[Slots] Upline remaining PT setting is required.",
  slots_account_min_required: "[Slots] Account minimum PT setting is required.",
  slots_upline_remaining_gt_account_pt: "[Slots] Upline remaining PT setting is greater than account PT setting.",
  slots_account_min_gt_pt: "[Slots] Account minimum PT setting is greater than parent PT setting.",
  lotto_upline_pt_required: "[Lotto] Upline PT setting is required.",
  lotto_pt_setting_exists: "[Lotto] PT setting is exists.",
  lotto_parent_pt_not_exists: "[Lotto] Parent PT setting does not exists.",
  lotto_parent_min_not_meet: "[Lotto] Does not match with parent minimum PT.",
  lotto_exceeded_parent_pt: "[Lotto] Exceeded parent PT setting.",
  lotto_account_pt_required: "[Lotto] Account PT setting is required.",
  lotto_upline_remaining_required: "[Lotto] Upline remaining PT setting is required.",
  lotto_account_min_required: "[Lotto] Account minimum PT setting is required.",
  lotto_upline_remaining_gt_account_pt: "[Lotto] Upline remaining PT setting is greater than account PT setting.",
  lotto_account_min_gt_pt: "[Lotto] Account minimum PT setting is greater than parent PT setting.",
  keno_upline_pt_required: "[Keno] Upline PT setting is required.",
  keno_pt_setting_exists: "[Keno] PT setting is exists.",
  keno_parent_pt_not_exists: "[Keno] Parent PT setting does not exists.",
  keno_parent_min_not_meet: "[Keno] Does not match with parent minimum PT.",
  keno_exceeded_parent_pt: "[Keno] Exceeded parent PT setting.",
  keno_account_pt_required: "[Keno] Account PT setting is required.",
  keno_upline_remaining_required: "[Keno] Upline remaining PT setting is required.",
  keno_account_min_required: "[Keno] Account minimum PT setting is required.",
  keno_upline_remaining_gt_account_pt: "[Keno] Upline remaining PT setting is greater than account PT setting.",
  keno_account_min_gt_pt: "[Keno] Account minimum PT setting is greater than parent PT setting.",
  cockfight_upline_pt_required: "[ESports2] Upline PT setting is required.",
  cockfight_pt_setting_exists: "[ESports2] PT setting is exists.",
  cockfight_parent_pt_not_exists: "[ESports2] Parent PT setting does not exists.",
  cockfight_parent_min_not_meet: "[ESports2] Does not match with parent minimum PT.",
  cockfight_exceeded_parent_pt: "[ESports2] Exceeded parent PT setting.",
  cockfight_account_pt_required: "[ESports2] Account PT setting is required.",
  cockfight_upline_remaining_required: "[ESports2] Upline remaining PT setting is required.",
  cockfight_account_min_required: "[ESports2] Account minimum PT setting is required.",
  cockfight_upline_remaining_gt_account_pt: "[ESports2] Upline remaining PT setting is greater than account PT setting.",
  cockfight_account_min_gt_pt: "[ESports2] Account minimum PT setting is greater than parent PT setting.",
  cockfight_exceeded_parent_commission: "[ESports2] Account commission setting is greater than parent commission setting.",
  lottery_upline_pt_required: "[Lottery] Upline PT setting is required.",
  lottery_pt_setting_exists: "[Lottery] PT setting is exists.",
  lottery_parent_pt_not_exists: "[Lottery] Parent PT setting does not exists.",
  lottery_parent_min_not_meet: "[Lottery] Does not match with parent minimum PT.",
  lottery_exceeded_parent_pt: "[Lottery] Exceeded parent PT setting.",
  lottery_account_pt_required: "[Lottery] Account PT setting is required.",
  lottery_upline_remaining_required: "[Lottery] Upline remaining PT setting is required.",
  lottery_account_min_required: "[Lottery] Account minimum PT setting is required.",
  lottery_upline_remaining_gt_account_pt: "[Lottery] Upline remaining PT setting is greater than account PT setting.",
  lottery_account_min_gt_pt: "[Lottery] Account minimum PT setting is greater than parent PT setting.",
  bet_type_required: "Bet type is required",
  schedule_1_to_7_required: "Settlement schedule is required",
  schedule_exists: "Settlement schedule does not exists.",
  parent_schedule_not_exists: "Parent settlement schedule does not exists.",
  schedule_1_not_available: "Settlement on Monday is not available.",
  schedule_2_not_available: "Settlement on Tuesday is not available.",
  schedule_3_not_available: "Settlement on Wednesday is not available.",
  schedule_4_not_available: "Settlement on Thursday is not available.",
  schedule_5_not_available: "Settlement on Friday is not available.",
  schedule_6_not_available: "Settlement on Saturday is not available.",
  schedule_7_not_available: "Settlement on Sunday is not available.",
  credit_limit_required: "Credit limit is required.",
  member_credit_limit_required: "Member credit limit is required.",
  wallet_exists: "Account is already exists.",
  member_credit_limit_gt_credit_limit: "Member credit limit is greater than credit limit.",
  parent_wallet_not_exists: "Account does not exists.",
  account_credit_limit_gt_parent: "Account credit limit is greater than parent credit limit.",
  member_credit_limit_gt_parent: "Member credit limit is greater than parent credit limit",
  exceeded_credit_limit: "Exceeded account credit limit.",
  soccer_min_bet_required: "Minimum bet is required.",
  soccer_max_bet_required: "Maximum bet is required.",
  soccer_max_per_match_required: "Maximum bet per match is required",
  soccer_bet_limit_exists: "Bet limit is already exists.",
  soccer_parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  soccer_account_min_bet_lt_parent: "Account min bet is lower than parent.",
  soccer_account_max_bet_gt_parent: "Account max bet is greater than parent",
  soccer_account_max_per_match_gt_parent: "Account maximum bet per match is greater than parent.",
  basketball_min_bet_required: "Minimum bet is required.",
  basketball_max_bet_required: "Maximum bet is required.",
  basketball_max_per_match_required: "Maximum bet per match is required",
  basketball_bet_limit_exists: "Bet limit is already exists.",
  basketball_parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  basketball_account_min_bet_lt_parent: "Account min bet is lower than parent.",
  basketball_account_max_bet_gt_parent: "Account max bet is greater than parent",
  basketball_account_max_per_match_gt_parent: "Account maximum bet per match is greater than parent.",
  tennis_min_bet_required: "Minimum bet is required.",
  tennis_max_bet_required: "Maximum bet is required.",
  tennis_max_per_match_required: "Maximum bet per match is required",
  tennis_bet_limit_exists: "Bet limit is already exists.",
  tennis_parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  tennis_account_min_bet_lt_parent: "Account min bet is lower than parent.",
  tennis_account_max_bet_gt_parent: "Account max bet is greater than parent",
  tennis_account_max_per_match_gt_parent: "Account maximum bet per match is greater than parent.",
  baseball_min_bet_required: "Minimum bet is required.",
  baseball_max_bet_required: "Maximum bet is required.",
  baseball_max_per_match_required: "Maximum bet per match is required",
  baseball_bet_limit_exists: "Bet limit is already exists.",
  baseball_parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  baseball_account_min_bet_lt_parent: "Account min bet is lower than parent.",
  baseball_account_max_bet_gt_parent: "Account max bet is greater than parent",
  baseball_account_max_per_match_gt_parent: "Account maximum bet per match is greater than parent.",
  parlay_min_bet_required: "Minimum bet is required.",
  parlay_max_bet_required: "Maximum bet is required.",
  parlay_max_per_match_required: "Maximum bet per match is required",
  parlay_bet_limit_exists: "Bet limit is already exists.",
  parlay_parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  parlay_account_min_bet_lt_parent: "Account min bet is lower than parent.",
  parlay_account_max_bet_gt_parent: "Account max bet is greater than parent",
  parlay_account_max_per_match_gt_parent: "Account maximum bet per match is greater than parent.",
  esports_min_bet_required: "Minimum bet is required.",
  esports_max_bet_required: "Maximum bet is required.",
  esports_max_per_match_required: "Maximum bet per match is required",
  esports_bet_limit_exists: "Bet limit is already exists.",
  esports_parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  esports_account_min_bet_lt_parent: "Account min bet is lower than parent.",
  esports_account_max_bet_gt_parent: "Account max bet is greater than parent",
  esports_account_max_per_match_gt_parent: "Account maximum bet per match is greater than parent.",
  others_min_bet_required: "Minimum bet is required.",
  others_max_bet_required: "Maximum bet is required.",
  others_max_per_match_required: "Maximum bet per match is required",
  others_bet_limit_exists: "Bet limit is already exists.",
  others_parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  others_account_min_bet_lt_parent: "Account min bet is lower than parent.",
  others_account_max_bet_gt_parent: "Account max bet is greater than parent",
  others_account_max_per_match_gt_parent: "Account maximum bet per match is greater than parent.",
  used_credit_gt_credit_limit: "Used credit limit is greater than credit limit.",
  bet_limit_setting_not_exists: "Bet limit setting does not exists.",
  parent_bet_limit_setting_not_exists: "Parent bet limit setting does not exists.",
  package_not_exists_in_parent: "Parent bet limit package setting does not exists",
  soccer_bet_limit_setting_not_exists: "Soccer bet limit setting does not exixts.",
  soccer_update_interval_violated: "Update interval violated.",
  basketball_bet_limit_setting_not_exists: "Basketball bet limit setting does not exixts.",
  basketball_update_interval_violated: "Update interval violated.",
  tennis_bet_limit_setting_not_exists:"Tennis bet limit setting does not exixts.",
  tennis_update_interval_violated: "Update interval violated.",
  baseball_bet_limit_setting_not_exists:"Baseball bet limit setting does not exixts.",
  baseball_update_interval_violated: "Update interval violated.",
  parlay_bet_limit_setting_not_exists:"Parlay bet limit setting does not exixts.",
  parlay_update_interval_violated: "Update interval violated.",
  esports_bet_limit_setting_not_exists:"Esports bet limit setting does not exixts.",
  esports_update_interval_violated: "Update interval violated.",
  others_bet_limit_setting_not_exists:"Others bet limit setting does not exixts.",
  others_update_interval_violated: "Update interval violated.",
  soccer_parent_bet_limit_setting_not_exists: "Soccer parent bet limit setting does not exixts.",
  soccer_min_bet_lt_parent: "Soccer account min bet is lower than parent.",
  soccer_max_bet_gt_parent: "Soccer account max bet is greater than parent.",
  soccer_max_per_match_gt_parent: "Soccer account max per match is greater than parent.",
  basketball_parent_bet_limit_setting_not_exists: "Basketball parent bet limit setting does not exixts.",
  basketball_min_bet_lt_parent: "Basketball account min bet is lower than parent.",
  basketball_max_bet_gt_parent: "Basketball account max bet is greater than parent.",
  basketball_max_per_match_gt_parent: "Basketball account max per match is greater than parent.",
  tennis_parent_bet_limit_setting_not_exists: "Tennis parent bet limit setting does not exixts.",
  tennis_min_bet_lt_parent: "Tennis account min bet is lower than parent.",
  tennis_max_bet_gt_parent: "Tennis account max bet is greater than parent.",
  tennis_max_per_match_gt_parent: "Tennis account max per match is greater than parent.",
  baseball_parent_bet_limit_setting_not_exists: "Baseball parent bet limit setting does not exixts.",
  baseball_min_bet_lt_parent: "Baseball account min bet is lower than parent.",
  baseball_max_bet_gt_parent: "Baseball account max bet is greater than parent.",
  baseball_max_per_match_gt_parent: "Baseball account max per match is greater than parent.",
  parlay_parent_bet_limit_setting_not_exists: "Parlay parent bet limit setting does not exixts.",
  parlay_min_bet_lt_parent: "Parlay account min bet is lower than parent.",
  parlay_max_bet_gt_parent: "Parlay account max bet is greater than parent.",
  parlay_max_per_match_gt_parent: "Parlay account max per match is greater than parent.",
  esports_parent_bet_limit_setting_not_exists: "ESports parent bet limit setting does not exixts.",
  esports_min_bet_lt_parent: "ESports account min bet is lower than parent.",
  esports_max_bet_gt_parent: "ESports account max bet is greater than parent.",
  esports_max_per_match_gt_parent: "ESports account max per match is greater than parent.",
  others_parent_bet_limit_setting_not_exists: "ESports parent bet limit setting does not exixts.",
  others_min_bet_lt_parent: "ESports account min bet is lower than parent.",
  others_max_bet_gt_parent: "ESports account max bet is greater than parent.",
  others_max_per_match_gt_parent: "ESports account max per match is greater than parent.",
  update_interval_violated: "Update interval violated.",
  exceeded_parent_others: "Exceeded parent others commission setting.",
  exceeded_parent_hdp: "Exceeded parent HDP bet limit setting.",
  no_information_available: "No information is available.",
  request_processing: "Processing request...",
  new_login_id_format_error: "Only lowercase characters and numbers from a to z and 0 to 9 allowed.",
  account_id_format_error: "Only lowercase characters and numbers from a to z and 0 to 9 allowed.",
  inactive_account: "Account has been closed/suspended. Please contact operator.",

  sportsbook_account_pt_gt_92: "Super Senior PT cannot greater than 92%",
  pending_result: "Pending result",
  insufficient_balance: "Insufficient balance",
  ok: "Succeed",
  settlement_warning: "Warning: if balance is fully transffered, the highlighted members below will have negative bet credit and consequently, they might lose more than their given credit.",
  jackpot_alert: "For any single progressive jackpot payout exceeding MYR 100,000 (THB 1,000,000),  WBET will bear the cost of the full amount.",
  accumulate_alert: "Win limits will reset once payment is settled in transfer list",
  filter_yesterday_balance: "Show Yesterday Balance not equal to 0",

  soccer_hdp_account_pt_lt_downline: "[Soccer] HDP Account PT is lower than downline",
  soccer_1x2_account_pt_lt_downline: "[Soccer] 1X2 Account PT is lower than downline",
  soccer_others_account_pt_lt_downline: "[Soccer] Others Account PT is lower than downline",
  soccer_hdp_exceeded_parent_pt: "[Soccer] Exceeded parent HDP PT setting.",
  soccer_1x2_exceeded_parent_pt: "[Soccer] Exceeded parent 1X2 PT setting.",
  soccer_others_exceeded_parent_pt: "[Soccer] Exceeded parent OTHERS PT setting.",
  parlay_account_pt_lt_downline: "[Parlay] Account PT is lower than downline",
  account_pt_lt_downline: "Account PT is lower than downline",
  player_alert_tooltips: "(Note: Only display member with credit less than min bet.)",

  relogin_seconds: "Please re-login after {timer} seconds",
  relogin_hours: "Please re-login after {timer} hours",
  relogin_tooltips: "If you require assistance with unlocking your account, please contact our customer service support.",
  last_modified_slot: "Your last modified time is {oldTime}. Please try again at {newTime}.",

  account_min_gt_pt: "Account minimum PT setting is greater than parent PT setting.",
  account_min_required: "Account minimum PT setting is required.",
  account_pt_required: "Account PT setting is required.",
  agent_id_required: "Agent ID is required.",
  amount_required: "Amount is required.",
  at_least_one_schedule_required: "At least one schedule setting is required.",
  authority_option_required: "Authority option setting is required.",

  baseball_min_bet_gt_max_bet: "Baseball min bet greater than max bet.",
  baseball_max_bet_gt_max_per_match: "Baseball max bet greater than max per match.",
  basketball_max_bet_gt_max_per_match: "Basketball max bet greater than max per match.",
  basketball_min_bet_gt_max_bet: "Basketball min bet greater than max bet.",
  brand_name_required: "Brand name is required",
  client_ip_required: "Client IP is required",

  cockfight_bet_limit_exists: "[ESports2] Bet limit is already exists.",
  cockfight_bet_limit_packages_required: "[ESports2] Bet limit packages are required.",
  cockfight_commission_required: "[ESports2] Commission setting is required.",
  cockfight_commission_setting_exists: "[ESports2] Commission setting is exists.",
  cockfight_invalid_bet_limit_package: "[ESports2] Invalid bet limit packages.",
  cockfight_member_bet_limit_package_gt_one: "[ESports2] Member bet limit packages is more than one.",
  cockfight_parent_bet_limit_not_exists: "[ESports2] Parent bet limit does not exists.",
  cockfight_parent_commission_not_exists: "[ESports2] Parent commission does not exists.",

  credit_limit_gt_parent_member_credit_limit: "Credit limit greater than parent member credit limit.",
  downline_limit_exceeded: "Downline limit exceeed.",

  esports_max_bet_gt_max_per_match: "[ESports] Max bet greater than max per match.",
  esports_min_bet_gt_max_bet: "[ESports] Min bet greater than max bet.",

  exceeded_parent_parlay_a: "Exceeded parent parlay A PT setting.",
  exceeded_parent_parlay_b: "Exceeded parent parlay B PT setting.",
  exceeded_parent_pt: "Exceeded parent parlay PT setting.",

  hdp_account_min_gt_pt: "HDP account min greater than parent PT.",
  hdp_account_min_required: "HDP account min setting is required.",
  hdp_account_pt_required: "HDP account PT setting is required.",
  hdp_exceeded_parent_commission: "HDP exceeded parent commission.",
  hdp_exceeded_parent_pt: "HDP exceeded parent PT.",
  hdp_mmo_account_min_gt_pt: "HDP MMO account min greater than parent PT.",
  hdp_mmo_account_min_required: "HDP MMO account min setting is required.",
  hdp_mmo_account_pt_required: "HDP MMO account PT setting is required.",
  hdp_mmo_commission_required: "HDP MMO commission is required.",
  hdp_mmo_exceeded_parent_commission: "HDP MMO exceeded parent commission.",
  hdp_mmo_exceeded_parent_pt: "HDP MMO exceeded parent PT.",
  hdp_mmo_parent_min_not_meet: "HDP MMO does not match with parent minimum PT.",
  hdp_mmo_parent_pt_not_exists: "HDP MMO parent PT setting does not exists.",
  hdp_mmo_pt_setting_exists: "HDP MMO PT setting is exists.",
  hdp_mmo_upline_pt_required: "HDP MMO Upline PT setting is required.",
  hdp_mmo_upline_remaining_gt_account_pt: "HDP MMO Upline remaining PT setting is greater than account PT setting.",
  hdp_mmo_upline_remaining_required: "HDP MMO Upline remaining PT setting is required.",
  hdp_package_required: "HDP packages is required.",
  hdp_packages_not_exists: "HDP packages does not exists.",
  hdp_packages_required: "HDP packages is required.",
  hdp_parent_min_not_meet: "HDP does not match with parent minimum PT.",
  hdp_parent_pt_not_exists: "HDP parent PT setting does not exists.",
  hdp_pt_setting_exists: "HDP PT setting is exists.",
  hdp_required: "HDP is required.",
  hdp_upline_pt_required: "HDP Upline PT setting is required.",
  hdp_upline_remaining_gt_account_pt: "HDP Upline remaining PT setting is greater than account PT setting.",
  hdp_upline_remaining_required: "HDP Upline remaining PT setting is required.",

  inactive_profile: "Inactive profile.",
  incorrect_format: "Incorrect format.",
  invalid_amount: "Invalid amount.",
  invalid_baseball_max_bet: "Invalid baseball max bet.",
  invalid_baseball_max_per_match: "Invalid baseball max per match.",
  invalid_baseball_min_bet: "Invalid baseball min bet.",
  invalid_basketball_max_bet: "Invalid basketball max bet,",
  invalid_basketball_max_per_match: "Invalid basketball max per match.",
  invalid_basketball_min_bet: "Invalid basketball min bet.",
  invalid_esports_max_bet: "Invalid Esports max bet.",
  invalid_esports_max_per_match: "Invalid Esports max per match.",
  invalid_esports_min_bet: "Invalid Esports min bet.",
  invalid_method: "Invalid method.",
  invalid_others_max_bet: "Invalid others max bet.",
  invalid_others_max_per_match: "Invalid others max per match.",
  invalid_others_min_bet: "Invalid others min bet.",
  invalid_parlay_max_bet: "Invalid parlay max bet.",
  invalid_parlay_max_per_match: "Invalid parlay max per match.",
  invalid_parlay_min_bet: "Invalid parlay min bet.",
  invalid_soccer_max_bet: "Invalid soccer max bet.",
  invalid_soccer_max_per_match: "Invalid soccer max per match.",
  invalid_soccer_min_bet: "Invalid soccer min bet.",
  invalid_tennis_max_bet: "Invalid tennis max bet.",
  invalid_tennis_max_per_match: "Invalid tennis max per match.",
  invalid_tennis_min_bet: "Invalid tennis min bet.",

  keno_bet_limit_exists: "[Keno] Bet limit is already exists.",
  keno_bet_limit_packages_required: "[Keno] Bet limit packages are required.",
  keno_commission_required: "[Keno] Commission setting is required.",
  keno_commission_setting_exists: "[Keno] Commission setting is exists.",
  keno_exceeded_parent_commission: "[Keno] Account commission setting is greater than parent commission setting.",
  keno_invalid_bet_limit_package: "[Keno] Invalid bet limit packages.",
  keno_member_bet_limit_package_gt_one: "[Keno] Member bet limit packages is more than one.",
  keno_parent_bet_limit_not_exists: "[Keno] Parent bet limit does not exists.",
  keno_parent_commission_not_exists: "[Keno] Parent commission does not exists.",

  livecasino_account_min_gt_pt: "[Livecasino] Account minimum PT setting is greater than parent PT setting.",
  livecasino_bet_limit_exists: "[Livecasino] Bet limit is already exists.",
  livecasino_bet_limit_packages_required: "[Livecasino] Bet limit packages are required.",
  livecasino_commission_required: "[Livecasino] Commission setting is required.",
  livecasino_commission_setting_exists: "[Livecasino] Commission setting is exists.",
  livecasino_exceeded_parent_commission: "[Livecasino] Account commission setting is greater than parent commission setting.",
  livecasino_invalid_bet_limit_package: "[Livecasino] Invalid bet limit packages.",
  livecasino_member_bet_limit_package_gt_one: "[Livecasino] Member bet limit packages is more than one.",
  livecasino_parent_bet_limit_not_exists: "[Livecasino] Parent bet limit does not exists.",
  livecasino_parent_commission_not_exists: "[Livecasino] Parent commission does not exists.",

  login_ip_required: "Login IP is required.",
  lottery_1d_parent_min_not_meet: "[Lottery 1D] Does not match with parent minimum PT.",
  lottery_1d_account_min_gt_pt: "[Lottery 1D] Account minimum PT setting is greater than parent PT setting.",
  lottery_1d_account_min_required: "[Lottery 1D] Account minimum PT setting is required.",
  lottery_1d_account_pt_lt_downline: "[Lottery 1D] Account PT is lower than downline.",
  lottery_1d_account_pt_required: "[Lottery 1D] Account PT setting is required.",
  lottery_1d_commission_required: "[Lottery 1D] Commission setting is required.",
  lottery_1d_exceeded_parent_comm: "[Lottery 1D] Account commission setting is greater than parent commission setting.",
  lottery_1d_exceeded_parent_commission: "[Lottery 1D] Account commission setting is greater than parent commission setting.",
  lottery_1d_exceeded_parent_pt: "[Lottery 1D] Exceeded parent PT setting.",
  lottery_1d_pt_setting_exists: "[Lottery 1D] Parent PT setting is exists.",
  lottery_1d_parent_pt_not_exists: "[Lottery 1D] Parent PT setting does not exists.",
  lottery_1d_pt_setting_not_exists: "[Lottery 1D] PT setting does not exists.",
  lottery_1d_upline_pt_required: "[Lottery 1D] Upline PT setting is required.",
  lottery_1d_upline_remaining_gt_account_pt: "[Lottery 1D] Upline remaining PT setting is greater than account PT setting.",
  lottery_1d_upline_remaining_required: "[Lottery 1D] Upline remaining PT setting is required.",

  lottery_2d_account_min_gt_pt: "[Lottery 2D] Account minimum PT setting is greater than parent PT setting.",
  lottery_2d_account_min_required: "[Lottery 2D] Account minimum PT setting is required.",
  lottery_2d_account_pt_lt_downline: "[Lottery 2D] Account PT is lower than downline.",
  lottery_2d_account_pt_required: "[Lottery 2D] Account PT setting is required.",
  lottery_2d_commission_required: "[Lottery 2D] Commission setting is required.",
  lottery_2d_exceeded_parent_comm: "[Lottery 2D] Account commission setting is greater than parent commission setting.",
  lottery_2d_exceeded_parent_commission: "[Lottery 2D] Account commission setting is greater than parent commission setting.",
  lottery_2d_exceeded_parent_pt: "[Lottery 2D] Exceeded parent PT setting.",
  lottery_2d_parent_min_not_meet: "[Lottery 2D] Does not match with parent minimum PT.",
  lottery_2d_parent_pt_not_exists: "[Lottery 2D] Parent PT setting does not exists.",
  lottery_2d_pt_setting_exists: "[Lottery 2D] Parent PT setting is exists.",
  lottery_2d_pt_setting_not_exists: "[Lottery 1D] PT setting does not exists.",
  lottery_2d_upline_pt_required: "[Lottery 2D] Upline PT setting is required.",
  lottery_2d_upline_remaining_gt_account_pt: "[Lottery 2D] Upline remaining PT setting is greater than account PT setting.",
  lottery_2d_upline_remaining_required: "[Lottery 2D] Upline remaining PT setting is required.",

  lottery_3d_commission_required: "[Lottery 3D] Commission setting is required.",
  lottery_3d_exceeded_parent_comm: "[Lottery 3D] Account commission setting is greater than parent commission setting.",
  lottery_3d_exceeded_parent_commission: "[Lottery 3D] Account commission setting is greater than parent commission setting.",
  lottery_4d_commission_required: "[Lottery 4D] Commission setting is required.",
  lottery_4d_exceeded_parent_comm: "[Lottery 4D] Account commission setting is greater than parent commission setting.",
  lottery_4d_exceeded_parent_commission: "[Lottery 4D] Account commission setting is greater than parent commission setting.",
  lottery_bet_limit_exists: "[Lottery] Bet limit is already exists.",
  lottery_bet_limit_packages_required: "[Lottery] Bet limit packages are required.",
  lottery_commission_setting_exists: "[Lottery] Commission setting is exists.",
  lottery_invalid_bet_limit_package: "[Lottery] Invalid bet limit packages.",
  lottery_member_bet_limit_package_gt_one: "[Lottery] Member bet limit packages is more than one.",
  lottery_parent_bet_limit_not_exists: "[Lottery] Parent bet limit does not exists.",
  lottery_parent_commission_not_exists: "[Lottery] Parent commission does not exists.",

  lotto_bet_limit_exists: "[Lotto] Bet limit is already exists.",
  lotto_bet_limit_packages_required: "[Lotto] Bet limit packages are required.",
  lotto_commission_required: "[Lotto] Commission setting is required.",
  lotto_commission_setting_exists: "[Lotto] Commission setting is exists.",
  lotto_exceeded_parent_commission: "[Lotto] Account commission setting is greater than parent commission setting.",
  lotto_invalid_bet_limit_package: "[Lotto] Invalid bet limit packages.",
  lotto_member_bet_limit_package_gt_one: "[Lotto] Member bet limit packages is more than one.",
  lotto_parent_bet_limit_not_exists: "[Lotto] Parent bet limit does not exists.",
  lotto_parent_commission_not_exists: "[Lotto] Parent commission does not exists.",

  method_required: "Method is required.",
  no_accumulate_win: "No accumulated win.",

  one_x_two_account_min_gt_pt: "[1X2] Account minimum PT setting is greater than parent PT setting.",
  one_x_two_account_min_required: "[1X2] Account minimum PT setting is required.",
  one_x_two_account_pt_required: "[1X2] Account PT setting is required.",
  one_x_two_commission_required: "[1X2] Commission setting is required.",
  one_x_two_exceeded_parent_commission: "[1X2] Account commission setting is greater than parent commission setting.",
  one_x_two_exceeded_parent_pt: "[1X2] Exceeded parent PT setting.",
  one_x_two_parent_min_not_meet: "[1X2] Does not match with parent minimum PT.",
  one_x_two_parent_pt_not_exists: "[1X2] Parent PT setting does not exists.",
  one_x_two_pt_setting_exists: "[1X2] PT setting does not exists.",
  one_x_two_upline_pt_required: "[1X2] Upline PT setting is required.",
  one_x_two_upline_remaining_gt_account_pt: "[1X2] Upline remaining PT setting is greater than account PT setting.",
  one_x_two_upline_remaining_required: "[1X2] Upline remaining PT setting is required.",

  others_account_min_gt_pt: "[Others] Account minimum PT setting is greater than parent PT setting.",
  others_account_min_required: "[Others] Account minimum PT setting is required.",
  others_account_pt_required: "[Others] Account PT setting is required.",
  others_exceeded_parent_commission: "[Others] Account commission setting is greater than parent commission setting.",
  others_exceeded_parent_pt: "[Others] Exceeded parent PT setting.",
  others_max_bet_gt_max_per_match: "[Others] Max bet is greater than max per match,",
  others_min_bet_gt_max_bet: "[Others] Min bet greater than max bet.",
  others_parent_min_not_meet: "[Others] Does not match with parent minimum PT.",
  others_parent_pt_not_exists: "[Others] Parent PT setting does not exists.",
  others_pt_setting_exists: "[Others] PT setting does not exists.",
  others_upline_pt_required: "[Others] Upline PT setting is required.",
  others_upline_remaining_gt_account_pt: "[Others] Upline remaining PT setting is greater than account PT setting.",
  others_upline_remaining_required: "[Others] Upline remaining PT setting is required.",

  parent_hdp_packages_not_exists: "HDP packages does not exists.",
  parent_pt_not_exists: "Parent PT setting does not exists.",
  parent_setting_not_exists: "PT setting does not exists.",
  parlay_a_commission_required: "[Parlay A] Commission setting is required.",
  parlay_a_exceeded_parent_commission: "[Parlay A] Account commission setting is greater than parent commission setting.",
  parlay_a_required: "[Parlay A] Setting is required.",
  parlay_account_min_gt_pt: "[Parlay] Account minimum PT setting is greater than parent PT setting.",
  parlay_account_min_required: "[Parlay] Account minimum PT setting is required.",
  parlay_account_pt_required: "[Parlay] Account PT setting is required.",
  parlay_b_commission_required: "[Parlay B] Commission setting is required.",
  parlay_b_exceeded_parent_commission: "[Parlay B] Account commission setting is greater than parent commission setting.",
  parlay_b_required: "[Parlay B] Setting is required.",
  parlay_exceeded_parent_pt: "[Parlay] Exceeded parent PT setting.",
  parlay_max_bet_gt_max_per_match: "[Parlay] Max bet greater than max per match.",
  parlay_min_bet_gt_max_bet: "[Parlay] Min bet greater than max bet.",
  parlay_mmo_account_min_gt_pt: "[Parlay MMO] Account minimum PT setting is greater than parent PT setting.",
  parlay_mmo_account_min_required: "[Parlay MMO] Account minimum PT setting is required.",
  parlay_mmo_account_pt_required: "[Parlay MMO] Account PT setting is required.",
  parlay_mmo_exceeded_parent_pt: "[Parlay MMO] Exceeded parent PT setting.",
  parlay_mmo_parent_min_not_meet: "[Parlay MMO] Does not match with parent minimum PT.",
  parlay_mmo_parent_pt_not_exists: "[Parlay MMO] Parent PT setting does not exists.",
  parlay_mmo_pt_setting_exists: "[Parlay MMO] PT setting does not exists.",
  parlay_mmo_upline_pt_required: "[Parlay MMO] Upline PT setting is required.",
  parlay_mmo_upline_remaining_gt_account_pt: "[Parlay MMO] Upline remaining PT setting is greater than account PT setting.",
  parlay_mmo_upline_remaining_required: "[Parlay MMO] Upline remaining PT setting is required.",
  parlay_parent_min_not_meet: "[Parlay] Does not match with parent minimum PT.",
  parlay_parent_pt_not_exists: "[Parlay] Parent PT setting does not exists.",
  parlay_pt_setting_exists: "[Parlay] PT setting does not exists.",
  parlay_pt_setting_not_exists: "[Parlay] PT setting does not exists.",
  parlay_upline_pt_required: "[Parlay] Upline PT setting is required.",
  parlay_upline_remaining_gt_account_pt: "[Parlay] Upline remaining PT setting is greater than account PT setting.",
  parlay_upline_remaining_required: "[Parlay] Upline remaining PT setting is required.",
  platform_code_required: "Platform code is required.",
  platform_name_required: "Platform name is required.",
  pt_setting_not_exists: "PT setting does not exists.",

  result_id_required: "Result ID is required.",
  schedule_not_exists: "Schedule does not exists.",

  slots_commission_required: "[Slots] Commission setting is required.",
  slots_commission_setting_exists: "[Slots] Commission setting is exists.",
  slots_exceeded_parent_commission: "[Slots] Account commission setting is greater than parent commission setting.",
  slots_parent_commission_not_exists: "[Slots] Parent commission does not exists.",

  soccer_1x2_account_min_gt_pt: "[1X2] Account minimum PT setting is greater than parent PT setting.",
  soccer_1x2_account_min_required: "[1X2] Account minimum PT setting is required.",
  soccer_1x2_account_pt_required: "[1X2] Account PT setting is required.",
  soccer_1x2_parent_pt_not_exists: "[1X2] Parent PT setting does not exists.",
  soccer_1x2_pt_setting_not_exists: "[1X2] PT setting does not exists.",
  soccer_1x2_upline_pt_required: "[1X2] Upline PT setting is required.",
  soccer_1x2_upline_remaining_gt_account_pt: "[1X2] Upline remaining PT setting is greater than account PT setting.",
  soccer_1x2_upline_remaining_required: "[1X2] Upline remaining PT setting is required.",
  soccer_hdp_account_min_gt_pt: "[HDP] Account minimum PT setting is greater than parent PT setting.",
  soccer_hdp_account_min_required: "[HDP] Account minimum PT setting is required.",
  soccer_hdp_account_pt_required: "[HDP] Account PT setting is required.",
  soccer_hdp_parent_pt_not_exists: "[HDP] Parent PT setting does not exists.",
  soccer_hdp_pt_setting_not_exists: "[HDP] PT setting does not exists.",
  soccer_hdp_upline_pt_required: "[HDP] Upline PT setting is required.",
  soccer_hdp_upline_remaining_gt_account_pt: "[HDP] Upline remaining PT setting is greater than account PT setting.",
  soccer_hdp_upline_remaining_required: "[HDP] Upline remaining PT setting is required.",
  soccer_max_bet_gt_max_per_match: "[Soccer] Max bet greater than max per match.",
  soccer_min_bet_gt_max_bet: "[Soccer] Min bet greater than max bet.",
  soccer_others_account_min_gt_pt: "[Others] Account minimum PT setting is greater than parent PT setting.",
  soccer_others_account_min_required: "[Others] Account minimum PT setting is required.",
  soccer_others_account_pt_required: "[Others] Account PT setting is required.",
  soccer_others_parent_pt_not_exists: "[Others] Parent PT setting does not exists.",
  soccer_others_pt_setting_not_exists: "[Others] PT setting does not exists.",
  soccer_others_upline_pt_required: "[Others] Upline PT setting is required.",
  soccer_others_upline_remaining_gt_account_pt: "[Others] Upline remaining PT setting is greater than account PT setting.",
  soccer_others_upline_remaining_required: "[Others] Upline remaining PT setting is required.",

  sportsbook_commission_setting_exists: "[Sportsbook] Commission setting is exists.",
  sportsbook_mmo_commission_setting_exists: "[Sportsbook MMO] Commission setting is exists.",
  sportsbook_mmo_parent_commission_not_exists: "[Sportsbook MMO] Parent commission setting does not exists.",
  sportsbook_parent_commission_not_exists: "[Sportsbook] Parent ommission setting does not exists.",
  status_required: "Status is required.",
  sub_not_exists: "Sub-account does not exists.",

  target_profile_id_required: "Target profile ID is required.",
  tennis_max_bet_gt_max_per_match: "[Tennis] Max bet greater than max per match.",
  tennis_min_bet_gt_max_bet: "[Tennis] Min bt greater than max bet.",
  tournament_commission_required: "Tournament commission is required.",
  tournament_commission_setting_exists: "Tournament commission setting is exists.",
  tournament_exceeded_parent_commission: "Tournament parent commission exceeeded.",
  tournament_parent_commission_not_exists: "Tournament parent commission does not exits.",

  upline_pt_required: "Upline PT setting is required.",
  upline_remaining_gt_account_pt: "Upline remaining PT setting is greater than account PT setting.",
  upline_remaining_required: "Upline remaining PT setting is required.",
  wallet_not_exists: "Wallet does not exists.",
  working_date_required: "Working date is required.",
  password_expired_alert: "Your password has expired. Please reset your password.",

  cs_min_bet_lt_soccer: "Minimum bet is lower than soccer minimum bet.",
  cs_max_bet_gt_soccer: "Maximum bet is greater than soccer maximum bet.",
  cs_max_per_match_gt_soccer: "Maximum bet per match is greater than soccer match per match.",
  cs_tooltips: "Correct score bet limit only comply to soccer bet limit",

  contact_phone_format_error: "Invalid contact phone format",
  contact_email_format_error: "Invalid contact email format",

  notice: "<div style='text-align: left;'><b><u>Notice: Update on Evolution Casino Betting Limits</u></b><br><br>Dear Valued Agent,<br><br>Please be informed that starting January 31, 2025, <b>Evolution Casino will no longer support company-imposed betting limits</b>. This adjustment means the platform will no longer restrict bet amounts, allowing for more flexibility in operations.<br><br>We appreciate your understanding and continued cooperation as we adapt to this change. Should you have any questions, feel free to contact our support team.<br><br>Thank you for your cooperation.</div>",

  // OTP 2FA Messages
  other_authenticator_apps_supported: "Other two-factor authenticator applications such as Sophos, Microsoft Authenticator etc. are also supported",
  date_time_automatic_required: "The Date & Time settings on your device must be set to Automatic.",
  get_otp_2fa_qr_code_failed: "Failed to get OTP 2FA QR code. Please try again.",
  enter_secret_manually: "Enter this secret manually in your authenticator app",
  otp_setup_failed: "Failed to setup OTP. Please try again.",
  otp_verification_failed: "Invalid verification code. Please try again.",
  otp_2fa_bound: "Google Authenticator has been successfully bound to your account.",
  invalid_code: "Invalid code. Please check the code and try again.",
  code_required: "Please enter the 6-digit code from your authenticator app.",
  otp_unbind_success: "OTP has been unbound successfully.",
  otp_unbind_failed: "Failed to unbind OTP 2FA. Please try again.",
  
  // Telegram OTP Messages
  telegram_chatbot_description: "Telegram Chatbot allows you to receive important business reports conveniently and securely without accessing the Agency site. Now you can also get OTP easily via Telegram Chatbot by enabling Telegram OTP notification.",
  telegram_setup_instructions: "To setup the chatbot, please follow the instructions below:",
  telegram_setup_failed: "Failed to setup Telegram. Please try again.",
  telegram_otp_bound: "Telegram OTP has been successfully enabled.",
  unbind_otp_confirm: "Are you sure you want to unbind OTP?",
  telegram_otp_sent: "OTP code has been sent to your Telegram",
  telegram_otp_request_failed: "Failed to request OTP. Please try again.",
  otp_unbind_first_to_use_other: "If you want to \"{module}\" , please unbind first.",
  invalid_parameter: "Invalid parameter.",
  remark_format_error: "Remark format error.",
  date_range_exceed: "Date range exceeds the maximum allowed range.",

  password_length_error: "Password must be at least 8 characters long.",
  password_whitespace_error: "Password cannot contain leading or trailing whitespace.",
  password_types_error: "Password must contain at least 3 character types.",
  password_consecutive_error: "Password cannot contain consecutive characters/numbers.",
  password_repeated_error: "Password must not contain repeated characters.",
  password_common_error: "Password must not contain common words.",

  security_code_required: "Security code is required.",
  security_code_error: "Security code must be exactly 6 digits.",
  security_digit_error: "Security code must contain at least 2 different digits.",
  security_consecutive_error: "Security code must not be consecutive numbers.",
  security_repeated_error: "Security code must not contain repeated patterns.",
  security_palindrome_error: "Security code must not be a palindrome.",
  security_weak_error: "Security code is too weak.",
  security_code_example: "For example: 123456, 765432, 456789, etc. are NOT allowed.",

  account_action_log_alert: "There have been password changes to this account line in the past 7 days.",
  unknown_error: "Unknown error."
};
